export const paginateData = (page, itemPerPage, allData) => {
    if (!Array.isArray(allData)) {
      return [];
    }
    const startIndex = page * itemPerPage
    const endIndex = page * itemPerPage + itemPerPage
    return allData.slice(startIndex, endIndex);
  }